import React from 'react';
import Offer1 from '../../../../Assets/StorefrontIcons/Offer1.svg';
import Offer2 from '../../../../Assets/StorefrontIcons/Offer2.svg';
import Offer3 from '../../../../Assets/StorefrontIcons/Offer3.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionFormType } from '../../../../Features/storefrontSlice';

function OfferDisplayButton() {
    const dispatch = useDispatch();

    const viewType = useSelector((state) => state.storefront.viewType);

    function handleClick() {
        dispatch(setSectionFormType(`OFFER_DISPLAY${viewType === 'MOBILE' ? '' : '_DESKTOP'}`));
    }

    return (
        <button onClick={handleClick} className="p-[10px] border border-[#EAEAEA] flex flex-col items-center gap-2 rounded-2xl select-none outline-none">
            <div className="w-full h-[100px] flex items-center justify-evenly rounded-md bg-[#EAEAEA] font-normal text-[10px] leading-5 text-[#121212]">
                <div className="w-[50px] h-20 rounded-md overflow-hidden">
                    <img className='size-full object-cover' src={Offer1} alt="" />
                </div>

                <div className="w-[50px] h-20 rounded-md overflow-hidden">
                    <img className='size-full object-cover' src={Offer2} alt="" />
                </div>

                <div className="w-[50px] h-20 rounded-md overflow-hidden">
                    <img className='size-full object-cover' src={Offer3} alt="" />
                </div>
            </div>

            <p className='font-medium text-[12px] leading-5 text-[#121212]'>Offer Display</p>
        </button>
    );
}

export default OfferDisplayButton;
